import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminAppBar from "./AdminAppBar";
import axios from "axios";
import LeadUploadService from "../Services/LeadUploadService";
import leadSourceService from "../Services/LeadSourceService";
import InterestedTagService from "../Services/InterestedTagService";
import propertyService from "../Services/PropertyService";
import teamService from "../Services/TeamService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { interestLevel, leadStatusMap } from "../../Enum";
import AppBar from "../leadComponent/AppBar";
import { showErrorToast, showSuccessToast } from "../Constant/Notification";
import userServices from "../Services/UserService";
import LocationService from "../Services/LocationService";
import { getBasePathByUserRole } from "../../utils/roleRoutes";
import CustomSelect from "../common/CustomSelect";
import CustomHeading from "../common/CustomHeading";
import LeadSourceDropdown from "../Form/LeadTable/LeadSourceDropdown";

const AdminManualUpload = () => {
  const navigate = useNavigate();

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const bodTeamId = userObj?.teamId?.[0]?.id;

  const path = getBasePathByUserRole();

  const handleAddLead = async () => {
    if (!validateForm()) return;
    setLoading(true);
  
    try {
     
      const tags = interestTags.map((item) => item.value);
      const locationTags = interestLocationTags.map((item) => item.value);
  
     
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailId && !emailRegex.test(emailId)) {
        showErrorToast("Invalid email ID. Please enter a valid email ID.");
        return;
      }
  
   
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(phone)) {
        toast.error("Invalid phone number. Please enter a 10-digit phone number.", {
          position: "top-center",
          theme: "light",
          className: "absolute top-20",
        });
        return;
      }
  
     
      const commonObj = {
        createdBy: userObj.user.uid,
        modifiedBy: userObj.user.uid,
        fieldWorker: selectedLeadGivenBy,
        interestTags: tags,
        interestedLocations: locationTags,
        leadSource: selectedLeadSource?.id || "",
        leadQuality: selectedLevel?.value || "",
        leads: [
          {
            name: name?.toLowerCase() || "",
            phoneNumber: String(phone),
            countryCode: "91",
            emailId: emailId || "",
          },
        ],
        status: selectedStatus || "",
      };
  
      let obj = {};
  
      if (["Admin", "CMO", "Lead Uploader"].includes(userRole)) {
        obj = {
          ...commonObj,
          assignedTeam: selectedTeam,
          assignedUser: isAssignedUser ? selectedUser : "",
        };
      } else if (userRole === "BOD") {
        obj = {
          ...commonObj,
          assignedTeam: bodTeamId,
          assignedUser: selectedUser,
        };
      }
  
     
      const response = await LeadUploadService.createBulkUpload(obj);
      console.log(response);
  
      if (response.status === 200) {
        showSuccessToast(response?.data || "Lead uploaded successfully");
      } else if (response.status === 201) {
        showSuccessToast("Lead uploaded successfully");
      }
  
      setTimeout(() => navigate(-1), 1500);
  
    } catch (error) {
      console.error(error);
      showErrorToast("Something went wrong while uploading the lead.");
    } finally {
      setLoading(false);
    }
  };
  


  const [interestTags, setInterestTags] = useState([]);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [options, setOptions] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [inputJson, setInputJson] = useState(null);
  const [leadSource, setLeadSource] = useState([]);
  const [leadSourceSearch , setLeadSourceSearch] = useState("");
  const [properties, setProperties] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState("");
  const [isAssignedTeam, setIsAssignedTeam] = useState(false);
  const [isAssignedUser, setIsAssignedUser] = useState(false);
  const [budget, setBudget] = useState();

  const [fieldWorkers, setFieldWorkers] = useState([]);

  const [interestedTags, setInterestedTags] = useState([]);
  const [leadGivenUsers, setLeadGivenUsers] = useState([]);
  const [selectedLeadGivenBy, setSelectedLeadGivenBy] = useState();
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [selectedProperty, setSelectedProperty] = useState("");

  const [selectedStatus, setSelectedStatus] = useState(
    leadStatusMap?.["Fresh"] || ""
  );

  const [selectedFieldWorker, setSelectedFieldWorker] = useState("");
  const [users, setUsers] = useState([]);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState();
  const [emailId, setEmailId] = useState("");
  const [errors, setErrors] = useState({});
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  const [selectedLevel, setSelectedLevel] = useState();

  const handleSelectChange = (selectedOption) => {
    setSelectedLevel(selectedOption);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      showErrorToast("Name is required");
      return;
    } else if (!phone) {
      showErrorToast("Phone number is required");
      return;
    } else if (!selectedLevel) {
      showErrorToast("Lead Quality is required");
      return;
    } else if (!selectedLeadSource) {
      showErrorToast("Lead Source is required");
    } else if (userRole !== "BOD" && !selectedTeam) {
      showErrorToast("Team is required");
    } else if (!selectedStatus) newErrors.status = "Status is required";

    // if (!name.trim()) newErrors.name = "Name is required";
    // if (!phone) newErrors.phone = "Phone number is required";
    // if (userRole !== "BOD") {
    //   if (!selectedTeam) newErrors.teams = "Team is required";
    // }
    // if (!selectedLeadSource) {
    //   showErrorToast("Lead Source is required");
    // }
    // // if (interestTags.length === 0)
    // //   showErrorToast("Interested Tag is required");
    // if (!selectedStatus) newErrors.status = "Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  } 

  const handleChange = (selectedOptions) => {
    setInterestTags(selectedOptions);
  };

  const handleLocationChange = (event) => {
    setInterestedLocationTags(event);
  };

  const handleBudgetChange = (e) => {
    setBudget(e.target.value);
  };

  const fetchLeadSourceData = async () => {
    try {
      const response = await leadSourceService.getLeadSource(leadSourceSearch);
      const data = response.data;
      console.log(data);
      setLeadSource(data || []);
    } catch (error) {
      console.error("Error fetching leadSources:", error);
      setLeadSource([])
    }
  }
  useEffect(()=>{
    fetchLeadSourceData();
  },[leadSourceSearch])

  useEffect(() => {
    (async () => {
      
      try {
        const responseTags = await InterestedTagService.fetchInterestedTag();
        const responseLocation = await LocationService.fetchLocation();
        const dataLocation = responseLocation.data;
        const formattedLocations = Object.entries(dataLocation).map(
          ([name, id]) => ({
            value: id,
            label: name,
          })
        );

        setOptionLocation(formattedLocations);
        console.log("Interest Location Data:", formattedLocations);

        const dataTags = responseTags.data;
        console.log("Interest Data:", dataTags);
        setInterestedTags(dataTags);

        const optionsArray = dataTags.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptions(optionsArray);
      } catch (error) {
        console.error("Error fetching interested tags:", error);
      }

      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams || [];
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }

      try {
        const response = await teamService.getUserName();
        const data = response.data?.users || [];
        setLeadGivenUsers(data);
      } catch (error) {
        console.log(error.message);
      }
    })();
  }, []);

  console.log("Data", optionLocation);


  const handleLeadAssignChange = (type) => {
    if (type === "Assign to team") {
      setIsAssignedTeam(true);
      setIsAssignedUser(false);
    } else if (type === "Assign to user") {
      setIsAssignedTeam(true);
      setIsAssignedUser(true);
    }
  };

  const handleTeamChange = async (e) => {
    setSelectedTeam(e);
    setErrors((prevErrors) => ({ ...prevErrors, teams: "" }));
  };

  useEffect(() => {
    const fetchUsersByTeam = async () => {
      let teamIdToFetch = userRole === "BOD" ? bodTeamId : selectedTeam;
      if (teamIdToFetch) {
        console.log(selectedTeam);
        try {
          const response = await teamService.getTeamData(teamIdToFetch); // Pass selectedTeam
          const data = response.data;
          console.log(data);
          const combinedUsers = [
            ...(Array.isArray(data.BOD) && data.BOD.length > 0
              ? data.BOD.map((bod) => ({ name: bod.name, id: bod.id }))
              : []),
            ...(data.MD && data.MD.name !== null && data.MD.id !== null
              ? [{ name: data.MD.name, id: data.MD.id }]
              : []),
            ...(Array.isArray(data.members) && data.members.length > 0
              ? data.members.map((member) => ({
                  name: member.name,
                  id: member.id,
                }))
              : []),
          ];

          const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];

          console.log("Final Users:", finalUsers);

          setUsers(finalUsers);
          console.log(users);
        } catch (error) {
          console.error("Error fetching users by team:", error);
          showErrorToast("Error fetching users");
        }
      }
    };

    fetchUsersByTeam();
  }, [selectedTeam, isAssignedUser]);
  const handleLeadSourceChange = (e) => {
    setSelectedLeadSource(e);
    setSelectedLeadSourceId(e.value);

    setErrors((prevErrors) => ({ ...prevErrors, leadSources: "" }));
  };

  // const handleStatusChange = (e) => {
  //   console.log(e);
  //   setSelectedStatus(leadStatusMap["Fresh"]);
  //   setErrors((prevErrors) => ({ ...prevErrors, status: "" }));
  // };

  const handleNameChange = (e) => {
    // setName(e.target.value);
    setName(
      e.target.value.replace(/\d/g, "").charAt(0).toUpperCase() +
        e.target.value.replace(/\d/g, "")
    );
  };

  const handlePhoneChange = (e) => {
    const newPhoneNumber = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPhone(newPhoneNumber.slice(0, 10)); // Limit to 10 digits
    setPhoneNumberError(
      newPhoneNumber.length !== 10 || /\D/.test(newPhoneNumber)
    );
    setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
  };

  const handleEmailChange = (e) => {
    setEmailId(e.target.value.toLowerCase());
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };


  return (
    <>
      {userRole === "Lead Uploader" ? <AppBar /> :  <AdminAppBar />}
      <ToastContainer />
      <div className=" bg-appGrayBackground flex flex-col gap-8  mt-20 pt-4 px-6 pb-10">
        <div className="flex justify-between">
        <CustomHeading title={"Manual Upload"} isIcon={true}/>

          <div className="">
            <button
              onClick={handleAddLead}
              className={`px-3 py-3 w-44 text-center ${
                loading ? "bg-gray-400 cursor-not-allowed" : "bg-customGreen"
              } text-white flex items-center text-base font-medium justify-center gap-2 rounded-[10px] transition duration-300`}
              disabled={loading}
            >
              Add Lead
            </button>
          </div>
        </div>

        <form className="flex flex-col px-[70px] mx-10 py-[37px] bg-white shadow rounded-[10px] h-full ">
        {/* <h2 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
                  Basic Information
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 text-xl font-medium">
                      Name <span className="text-red-500">*</span>
                    </label>
                    <div className="md:col-span-3">
                      <input
                        className={`w-full px-3 py-2 border rounded-md input-focus ${
                          errors.name ? "border-red-500" : "border-gray-300"
                        }`}
                        type="text"
                        value={name}
                        placeholder="Enter lead name"
                        onChange={handleNameChange}
                      />
                    </div>
                  </div> */}
          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Name <span className="text-red-600">*</span>
            </label>
            <input
              className={`shadow appearance-none border rounded w-3/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name && "border-red-500"
              }`}
              id="name"
              type="text"
              value={name}
              maxLength={50}
              placeholder={errors.name || "Enter User Name"}
              // onChange={(e) => handleNameChange(e)}
              onChange={(e) => {
                setName(
                  e.target.value.replace(/\d/g, "").charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                );
                setErrors((prevErrors) => ({ ...prevErrors, name: "" }));
              }}
            />
          </div>
          <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Phone Number <span className="text-red-600">*</span>
            </label>

            <input
              className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.phone && "border-red-500"
              }`}
              id="phone-number"
              type="tel"
              pattern="[0-9]{10}"
              value={phone}
              placeholder={
                phoneNumberError
                  ? "Invalid phone number format"
                  : "Enter Phone Number"
              }
              onChange={handlePhoneChange}
            />
          </div>
          <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Email ID
            </label>
            <input
              className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="email"
              type="email"
              value={emailId}
              placeholder="Enter your email"
              onChange={(e) => handleEmailChange(e)}
            />
          </div>
          <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Lead Quality <span className="text-red-600">*</span>
            </label>
            <div className="w-3/4 ">

            <CustomSelect
           value={selectedLevel}
           placeholder="Select Lead Quality"
           onChange={handleSelectChange}
           options={interestLevel}
         
      
            
            />
              {/* <Select
                className="w-full bg-transparent text-gray-700 focus:outline-none"
                value={selectedLevel}
                placeholder="Select Lead Quality"
                onChange={handleSelectChange}
                options={interestLevel}
                formatOptionLabel={(e) => (
                  <div className="flex items-center">
                    <img src={e.image} alt={e.label} className="w-6 h-6 mr-2" />
                    <span
                      className={`${getBackgroundClass(e.label)} font-bold `}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
                styles={customStyles}
              /> */}
            </div>
          </div>
          <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Lead Source <span className="text-red-600">*</span>
            </label>
            <div className="flex w-3/4">

            <LeadSourceDropdown
              leadSource={leadSource}
              setLeadSourceSearch={setLeadSourceSearch}
              leadSourceSearch={leadSourceSearch}
              onSelect={(list) => {
                setSelectedLeadSource(list);
                ;
              }}
            />
              {/* <Select
                options={leadSources.map((source) => ({
                  value: source.id,
                  label: source.name,
                }))}
                onChange={handleLeadSourceChange}
                value={selectedLeadSource}
                placeholder="Select Lead Source"
                isClearable
                isSearchable
                className="w-full focus:outline-none focus:shadow-outline"
              /> */}
            </div>
          </div>
          <div className="mb-4 flex  items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Interest Tag
            </label>
            <div className="flex w-3/4   ">
            <CustomSelect
           value={interestTags}
           onChange={handleChange}
           options={options}
           isMulti
           placeholder="Type Interest Tags"
            
            />
              {/* <Select
                className={`w-full py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.interestTags && "border-red-500"
                }`}
                value={interestTags}
                onChange={handleChange}
                options={options}
                isMulti
                menuPlacement="top"
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "100px",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#339E79", // Change background color of the chip
                    borderRadius: "4px",
                    padding: "2px 4px",
                    color: "white", // Change text color of the chip
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: "white", // Change text color of the label inside the chip
                  }),
                }}
                placeholder={errors.interestTags || "Type to search eg :"}
              /> */}
            </div>
          </div>

          <div className="mb-4 flex  items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Interest locations
            </label>
            <div className="flex w-3/4   ">
            <CustomSelect
           value={interestLocationTags}
           onChange={handleLocationChange}
           options={optionLocation}
           isMulti
           placeholder="Type Interest Location"
            
            />
              {/* <Select
                className={`w-full py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.interestTags && "border-red-500"
                }`}
                value={interestLocationTags}
                onChange={handleLocationChange}
                options={optionLocation}
                isMulti
                menuPlacement="top"
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "100px",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#339E79", // Change background color of the chip
                    borderRadius: "4px",
                    padding: "2px 4px",
                    color: "white", // Change text color of the chip
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: "white", // Change text color of the label inside the chip
                  }),
                }}
                placeholder={errors.interestTags || "Type to search eg :"}
              /> */}
            </div>
          </div>

          {/*
            <div className="flex items-center mb-4 ">

              <div className="w-1/4"></div>
              <div className="3/4 flex gap-40 ">

<label htmlFor="" className="flex gap-2">
  <input type="radio"
  value={"Assign to team"}
  id="assign-team"
  className="w-4"
  checked={isAssignedTeam && !isAssignedUser}
    onChange={() => handleLeadAssignChange("Assign to team")}   />
  <span>Assign to team</span>
</label>

<label htmlFor="" className="flex gap-2">
  <input type="radio"
  value={"Assign to user"}
  id="assign-user"
    className="w-4"
    checked={isAssignedUser}
      onChange={() => handleLeadAssignChange("Assign to user")}    />
  <span>Assign to user</span>
</label>
</div>

            </div>
{ isAssignedTeam &&(

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl font-bold"
              htmlFor="lead-source"
            >
              Assign to team
            </label>
            {userRole === "BOD" ? (
              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="name"
                value={userObj.teamId[0].name}
                readOnly
              />
            ) : (
              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  id="lead-source"
                  name="lead-source"
                  onChange={(e) => handleTeamChange(e.target.value)}
                >
                  <option value="">Select Team</option>

                  {teams.map((item, index) => {
                    return (
                      <option key={index} value={item.teamId}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 24 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                      fill="#399E79"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>

)
        }
 {isAssignedUser && (          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl font-bold"
              htmlFor="lead-source"
            >
              Assign to user
            </label>

              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  id="lead-source"
                  name="lead-source"
                  onChange={(e) =>setSelectedUser(e.target.value) }
                >
                  <option value="">Select User</option>

                  {users.map((item, index) => {
                    return (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 24 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                      fill="#399E79"
                    />
                  </svg>
                </div>
              </div>
          </div>
)} */}

          <div className="flex items-center mb-4">
            <div className="w-1/4"></div>
            {userRole !== "BOD" && (
              <div className="3/4 flex gap-40">
                <label htmlFor="" className="flex gap-2">
                  <input
                    type="radio"
                    value="Assign to team"
                    id="assign-team"
                    className="w-4"
                    checked={isAssignedTeam && !isAssignedUser}
                    onChange={() => handleLeadAssignChange("Assign to team")}
                  />
                  <span>
                    Assign to team <span className="text-red-600">*</span>
                  </span>
                </label>

                <label htmlFor="" className="flex gap-2">
                  <input
                    type="radio"
                    value="Assign to user"
                    id="assign-user"
                    className="w-4"
                    checked={isAssignedUser}
                    onChange={() => handleLeadAssignChange("Assign to user")}
                  />
                  <span>
                    Assign to user <span className="text-red-600">*</span>
                  </span>
                </label>
              </div>
            )}
          </div>

          {isAssignedTeam && userRole !== "BOD" && (
            <div className="mb-8 flex items-center">
             <label className="w-1/4 text-black text-xl font-medium ">
                Assign to team <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => handleTeamChange(e.target.value)}
                >
                  <option value="">Select Team</option>
                  {teams.map((item, index) => (
                    <option key={index} value={item.teamId}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {(isAssignedUser || userRole === "BOD") && (
            <div className="mb-8 flex items-center">
             <label className="w-1/4 text-black text-xl font-medium ">
                Assign to user <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="">Select User</option>
                  {users.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          {/*
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl font-bold"
              htmlFor="lead-source"
            >
              Status <span className="text-red-600">*</span>
            </label>
            <div className="flex w-3/4 relative">
              <select
                className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.status && "border-red-500"
                }`}
                id="lead-source"
                name="lead-source"
                onChange={(e) => handleStatusChange(e.target.value)}
              >


                {status.map((item, index) => {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 24 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                    fill="#399E79"
                  />
                </svg>
              </div>
            </div>
          </div> */}

          <div className="mb-8 flex items-center">
          <label className="w-1/4 text-black text-xl font-medium ">
              Lead Given By{" "}
            </label>
            <div className="flex w-3/4 relative">
              <select
                className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="lead-source"
                name="lead-source"
                onChange={(e) => setSelectedLeadGivenBy(e.target.value)}
              >
                <option value="">Select Lead Given By</option>

                {Array.isArray(leadGivenUsers) &&
                  leadGivenUsers.map((item, index) => {
                    return (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 24 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                    fill="#399E79"
                  />
                </svg>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AdminManualUpload;
